module.exports = __webpack_public_path__ + "static/media/baseline-gps_fixed-24px.440ea8fe.svg";